import { Backend } from '.';

export interface Customer {
  allow_promotion?: boolean;
  address_addition?: string;
  birthday_on?: Date;
  city: string;
  companyname?: string;
  country?: string;
  created_at?: Date;
  eid?: string; // external id
  email: string;
  fax?: string;
  firstname: string;
  gender?: string;
  id: number;
  lastname: string;
  mobile?: string;
  phone?: string;
  position?: string;
  provider?: string;
  salutation?: string;
  state?: string;
  street: string;
  title?: string;
  updated_at: Date;
  zip_code: string;
}

export type CreatableCustomer = Omit<Customer, 'id' | 'eid' | 'created_at' | 'updated_at'>;
export type ModifiableCustomer = Omit<CreatableCustomer, 'email'>;
export interface RegisterableCustomer extends CreatableCustomer {
  password: string;
  passwordRepeat: string;
}

export async function login(username: string, password: string) {
  return Backend.post<void>(`/session`, {
    body: JSON.stringify({
      customer: {
        email: username,
        password,
      },
    }),
  });
}

export async function logout() {
  return Backend.del<void>(`/session`);
}

export async function createCustomer(customer: CreatableCustomer) {
  return Backend.post<Customer>(`/customer`, {
    body: JSON.stringify({
      customer,
    }),
  });
}

export async function getCustomer() {
  return Backend.get<Customer>(`/customer`);
}

export async function updateCustomer(customer: ModifiableCustomer) {
  return Backend.put<Customer>(`/customer`, {
    body: JSON.stringify({
      customer,
    }),
  });
}

export async function patchCustomer(customer: Partial<ModifiableCustomer>) {
  return Backend.patch<Customer>(`/customer`, {
    body: JSON.stringify({
      customer,
    }),
  });
}

export async function confirmCustomer(token: string) {
  return Backend.get<void>(`/customer/confirm/${encodeURIComponent(token)}`);
}

export async function deleteCustomer() {
  return Backend.del<void>(`/customer`);
}

export async function requestPasswordReset(email: string) {
  return Backend.post<void>(`/password`, {
    body: JSON.stringify({ email }),
  });
}

export async function resetPassword(password: string, passwordConfirmation: string, token: string) {
  return Backend.patch<void>(`/password`, {
    body: JSON.stringify({
      customer: {
        password,
        password_confirmation: passwordConfirmation,
      },
      token,
    }),
  });
}

export async function upgradeToCustomer(orderId: number, xtoken: string, password: string) {
  return Backend.post<Customer>(`/customer/upgrade/${orderId}/${xtoken}`, {
    body: JSON.stringify({
      customer: {
        password,
      },
    }),
  });
}
